import React, { Component, KeyboardEvent } from "react";
import Strings from "@my-dld/assets/strings";
import { ILoginComponent, LoginType } from "./index";
import { ILoader } from "../index";
import { ServerDate, StringUtil } from "@eres/core";
import { Entities, IdentityApi } from "@10x/dubai-rest-api";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import TextInputField from "@my-dld/components/Form/TextInputField";
import DateInputField from "@eres/forms-web/DateInputField";
import StateHolder from "@eres/forms/StateHolder";
import { ErrorContainer } from "@eres/forms";
import { showErrorMessage } from "@my-dld/utils/UIUtils";

interface State {
	email?: string;
	dob?: ServerDate;
	errorContainer: ErrorContainer;
}

export function MobileStateFormatter( eid: string ) {
	return "+" + eid.replace( /\D/g, "" );//eid.replace(/_/g, "").replace(/-/g, "").replace(/\s/g, "");
}

export class EmailLogin extends Component<any, State> implements ILoginComponent<any, State> {
	today = new Date();

	constructor( props: any ) {
		super( props );
		this.state = {
			errorContainer: {},
			email: "",
		};
	}

	render() {
		const ds = StateHolder.buildStateHolder( this );
		return (
			<>
				<TextInputField
					containerClassName={ "form-group" }
					inputClassName={ "form-control ltr-text-field" }
					placeHolder={ "name@organisation.com" }
					id={ "email" }
					holder={ this }
					required={ true }
					error={ this.state.errorContainer?.mobile }
					label={ Strings.registered_email }
				>
				</TextInputField>
				<DateInputField
					containerClassName={ "field-style form-group-icon" }
					required={ true }
					holder={ ds }
					label={ Strings.date_of_birth }
					id={ "dob" }
					extraOpts={ {
						maxDate: this.today,
						yearRange: "-100:+0"
					} }
				/>
			</>
		);
	}

	onKeyUp = ( event: KeyboardEvent<any> ) => {
		if ( event.charCode === 13 ) {
			this.props.doLogin();
		}
	};
	doLogin = ( loader: ILoader ) => {
		loader.setLoading( true );
		let isValid = true;
		const errorContainer: ErrorContainer = {};
		let email = this.state.email ? this.state.email! : undefined;

		if ( StringUtil.isEmptyStringOrNull( email ) || !StringUtil.isEmailAddress( email! ) ) {
			isValid = false;
			errorContainer.mobile = Strings.please_enter_valid_email;
		}
		if ( StringUtil.isEmptyStringOrNull( this.state.dob ) ) {
			errorContainer[ "dob" ] = Strings.please_enter_dob;
			isValid = false;
		}
		this.setState( { errorContainer: errorContainer } );
		if ( isValid ) {
			let email = this.state.email!;
			trackEventWithData( "Login", "TryLogin", { method: "Email", id: email } );
			return IdentityApi.loginByEmail( email, this.state.dob! )
			.then( Entities.validateResponse )
			.then( profile => {
				loader.setLoading( false );
				return {
					result: profile,
					method: "Email" as LoginType,
					id: email,
					dob: this.state.dob!
				};
			} )
			.catch( e => {
				loader.setLoading( false );
				showErrorMessage( e );
				return Promise.reject();
			} );
		}
		loader.setLoading( false );
		return Promise.reject();
	};
}
